var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKevinLogoHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 42,
    viewBox: "0 0 141 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 33.0011V15H1.91771V33.0011H0ZM1.65865 28.5258L1.5795 26.2114L12.564 15H14.766L6.76055 23.3327L5.67396 24.4899L1.65865 28.5258ZM13.0318 33.0011L5.20983 24.0506L6.50509 22.6612L15.3129 32.9976H13.0318V33.0011Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6308 31.3581H32.5362V33.0047H19.7131V15.0035H32.1476V16.6501H21.6308V31.3581ZM21.4222 23.0505H31.0071V24.672H21.4222V23.0505Z",
    fill: "#F2F2F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2364 33.0011L35.2058 15H37.2782L44.7907 31.9475H43.6502L51.2131 15H53.156L45.1254 33.0011H43.2328H43.2364Z",
    fill: "#F2F2F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0706 33.0011V15H58.9883V33.0011H57.0706Z",
    fill: "#F2F2F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1877 33.0011V15H67.7672L80.2809 30.6367H79.4534V15H81.3459V33.0011H79.7664L67.2815 17.3644H68.109V33.0011H66.1913H66.1877Z",
    fill: "#F2F2F2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0273 33.0011V15H91.395V30.1724H100.876V33.0011H88.0273Z",
    fill: "#F2F2F2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M102.301 33.0011L110.461 15H113.778L121.963 33.0011H118.441L111.421 16.7751H112.767L105.773 33.0011H102.301ZM106.057 28.8366L106.963 26.215H116.757L117.664 28.8366H106.057Z",
    fill: "#F2F2F2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M122.456 33.0011L130.098 22.5612V25.0827L122.82 15.0035H126.626L132.041 22.4611L130.487 22.4861L135.848 15.0035H139.5L132.271 24.9042V22.4861L139.964 33.0047H136.078L130.379 25.0827H131.908L126.288 33.0047H122.453L122.456 33.0011Z",
    fill: "#F2F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKevinLogoHeader);
export default __webpack_public_path__ + "static/media/KevinLogo_Header.abc08b0ddc04cfcc2003c0b8a37c349b.svg";
export { ForwardRef as ReactComponent };